import Button from 'molecules/Button';
import styles from 'molecules/FeaturedText/featured-text.module.scss';
import RichText from 'molecules/RichText';
import FeaturedTextStats from 'molecules/Stats';

import type { FeaturedTextProps } from 'molecules/FeaturedText/config';
import type { FC } from 'react';

export type MoleculeFeaturedTextProps = FeaturedTextProps;

const FeaturedText: FC<MoleculeFeaturedTextProps> = ({ eyebrow, content, callToAction, featuredStats }) => (
  <div className={styles.featuredTextContainer}>
    {eyebrow && <p className={styles.featuredTextEyebrow}>{eyebrow}</p>}
    {content && <RichText className={styles.featuredTextBody} content={content} />}
    {featuredStats && <FeaturedTextStats featuredStats={featuredStats} statClass={styles.stat} />}
    {callToAction?.text && (
      <div>
        <Button className={styles.arrowLink} direction="right" url={callToAction?.link} iconId="arrow-right">
          {callToAction?.text}
        </Button>
      </div>
    )}
  </div>
);

export default FeaturedText;
